<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-12 col-md-6">
          <h2>NTS Performance by Business Unit - Scatter Graph</h2>
        </div>
        <div class="col-12 col-md-6">
          <div class="rating-container float-md-right mb-3">
            <RateCapability :qAppId="qAppIdRatingValue"></RateCapability>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <QlikViz
            vizId="pzvnTJ"
            noHeader="true"
            class="qlikText text-center"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-3 my-4">
          <QlikViz vizId="MQPxzDq" noHeader="true" class="filterRLD" />
        </div>
      </div>          
      <div class="row row-object one-viz-row">
        <div class="col">
          <QlikViz vizId="2b176cec-36ee-4ddd-9378-4f91fb70d0e8" vizTitle="NTS" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import qAPI from "../../../services/qAPI";
import page from "../../../mixins/page";

export default {
  name: "NTSPerformance",
  props: [],

  mixins: [page],
  data() {
    return {
      pageName: this.$route.name,
      mashup: null,
      qObjects:
        "pzvnTJ,MQPxzDq,2b176cec-36ee-4ddd-9378-4f91fb70d0e8",
      qFilterObjects: [
        {
          id: "c3796e17-b704-4a61-a878-eff6c1c23d8b",
          nFilters: 4
        },
        {
          id: "918d07f8-f09c-41a5-ad47-954d77e12dfa",
          nFilters: 5
        },
        {
          id: "bd95e628-5bba-4c80-8a56-44ce8cb6689b",
          nFilters: 4
        }
      ],
    };
  },
  async mounted() {
    await this.init(this.$route, this.qObjects, this.qFilterObjects);
  },
  async destroyed() {
    qAPI.closeQlikObjectsInStore(this.qObjects.split(","));
  },
};
</script>
<style>
.filterRLD .card {
  border: 0;
}

.filterRLD .card-body {
  padding: 0;
  height: 35px;
}

.filterRLD .card-body .rain .progress-div {
  background-size: 35px;
}
</style>
